import {
  HIDE_CLIENT_LOADER,
  HIDE_CLIENTS_LIST_LOADER,
  SET_CLIENT,
  SET_CLIENTS_LIST,
  SET_ERROR_CLIENT,
  SHOW_CLIENT_LOADER,
  SHOW_CLIENTS_LIST_LOADER,
} from "./actionTypes";

const INIT_STATE = {
  data: {
    count: 0,
    next: null,
    previous: null,
    page: 1,
    sizePerPage: 10,
    results: [],
  },
  loading: false,
  client: {},
  isError: false,
  client_loading: false,
};

const Clients = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CLIENTS_LIST:
      return {
        ...state,
        data: action.payload,
      };
    case SHOW_CLIENTS_LIST_LOADER:
      return {
        ...state,
        loading: true,
      };
    case HIDE_CLIENTS_LIST_LOADER:
      return {
        ...state,
        loading: false,
      };
    case SET_CLIENT:
      return {
        ...state,
        client: action.payload,
      };
    case SHOW_CLIENT_LOADER:
      return {
        ...state,
        client_loading: true,
      };
    case HIDE_CLIENT_LOADER:
      return {
        ...state,
        client_loading: false,
      };
    case SET_ERROR_CLIENT:
      return {
        ...state,
        isError: action.payload,
      };
    default:
      return state;
  }
};

export default Clients;
